import { render, staticRenderFns } from "./alergiasComponent.vue?vue&type=template&id=32f65c13"
import script from "./alergiasComponent.vue?vue&type=script&lang=js"
export * from "./alergiasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports